module.exports = __webpack_public_path__ + "img/tick-filled.1fca55be.svg";